import React from "react";

const CheckboxGroupSection = ({
  isEditing,
  label,
  value = [],
  onChange,
  options = [],
}) => {
  const toggle = (val) => {
    if (!isEditing) return;
    const exists = value.includes(val);
    const next = exists ? value.filter((v) => v !== val) : [...value, val];
    onChange(next);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <h2 className="text-[11px] font-bold text-[#3C3C3C] mb-3">{label}</h2>
      <div className="grid grid-cols-2 gap-3">
        {options.map((opt) => (
          <label key={opt.value} className={`flex items-center gap-2 text-[14px] ${!isEditing ? 'opacity-60' : ''}`}>
            <input
              type="checkbox"
              checked={value.includes(opt.value)}
              onChange={() => toggle(opt.value)}
              disabled={!isEditing}
              className="w-4 h-4"
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroupSection;

